export const TYPE = [
  'netral',
  'diskon',
  'grosir',
  'call-out',
  ''
]

export const POSITION = [
  'top-left', 
  'bottom-right',
  ''
]
